<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="register-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos//assets/images/logos/logogro.png">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            <span class="name_title">e</span>.Justicia
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Iniciamos una nueva era en la impartición de Justicia Administrativa
        </div>

    </div>

    <div id="register-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="register-form">

            <div class="logo" fxHide.gt-xs>
                <img src="assets/images/logos//assets/images/logos/logogro.png">
            </div>

            <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}" fxHide.gt-xs>
                <span class="name_title">e</span>.Justicia
                <div class="h2 email">Administrativa Durango</div>
            </div>

            <div class="title">
                <div class="h2">Asesoría Ciudadana Administrativa en línea</div>
            </div>

            <div>
                <p>Esta página está diseñada con la finalidad de proporcionar a las personas físicas de la entidad  que requieran de asesoría legal gratuita sobre la tramitación de los juicios contenciosos administrativos y fiscales ante el Tribunal
                    de Justicia Administrativa del Estado de Durango.</p>
            </div>


            <form name="registerForm" [formGroup]="registerForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        Nombre es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Apellido Paterno</mat-label>
                    <input matInput formControlName="paterno" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        Apellido paterno es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Apellido Materno</mat-label>
                    <input matInput formControlName="materno" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>
                        Apellido materno es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Teléfono móvil</mat-label>
                    <input matInput type="tel" formControlName="telefono">
                    <mat-icon matSuffix class="secondary-text">tel</mat-icon>
                    <!-- <mat-error *ngIf="citizenForm.get('telefono').hasError('pattern')">El telefono debe contener solo números</mat-error>
                    <mat-error *ngIf="!citizenForm.get('telefono').hasError('pattern') &&
                                    citizenForm.get('telefono').hasError('minlength')">El telefono debe contener al menos 10 digitos</mat-error>
                 -->
                                </mat-form-field>
                <br>
                
                <mat-form-field appearance="outline">
                    <mat-label>Correo electrónico</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <!-- <mat-error *ngIf="citizenForm.get('email').hasError('email')">
                        Por favor ingresa un correo valido
                    </mat-error> -->
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-select formControlName="muni" required>
                        <mat-option>-- Selecciona uno --</mat-option>
                        <mat-option *ngFor="let item of municipalities" value="{{item.nume}}">{{item.nomb}}</mat-option>
                    </mat-select>
                    <mat-label>
                        Municipio
                    </mat-label>
                    <mat-error>Debes seleccionar un municipio</mat-error>
                </mat-form-field>

                <!--mat-form-field appearance="outline">
                    <mat-select formControlName="tpau" (selectionChange)="_getNamesList()" required>
                        <mat-option>-- Selecciona uno --</mat-option>
                        <mat-option value="estatal">Estatal</mat-option>
                        <mat-option value="municipal">Municipal</mat-option>
                        <mat-option value="particular">Particular</mat-option>
                    </mat-select>
                    <mat-label>
                        Tipo Autoridad
                    </mat-label>
                    <mat-error>Debes seleccionar un tipo de autoridad</mat-error>
                </mat-form-field-->

                <mat-form-field appearance="outline">
                    <mat-label>Localidad o dirección:</mat-label>
                    <input matInput formControlName="dire" required>
                    <mat-icon matSuffix class="secondary-text">bussiness</mat-icon>
                    <mat-error>
                        Debes agregar una dirección
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Breve descripción de la consulta o asesoría:</mat-label>
                    <textarea matInput formControlName="desc" rows="5" required></textarea>
                    <mat-icon matSuffix class="secondary-text">bussiness</mat-icon>
                    <mat-error>
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Autoridad estatal, municipal u organismo público descentralizado que ha dictado, ejecute o trate de ejecutar el acto de molestia:</mat-label>
                    <textarea matInput formControlName="auto" rows="5" required></textarea>
                    <mat-icon matSuffix class="secondary-text">bussiness</mat-icon>
                    <mat-error>
                        Este campo es obligatorio
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>En su caso, indica los documentos relacionados con la consulta o asesoría</mat-label>
                    <textarea matInput formControlName="docu" rows="5"></textarea>
                    <mat-icon matSuffix class="secondary-text">bussiness</mat-icon>
                    <mat-error>
                        Campo obligatorio
                    </mat-error>
                </mat-form-field>

                <!--mat-form-field class="example-full-width">
                    <mat-label>Assignee</mat-label>
                    <input type="text" matInput [formControl]="auto" [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" *ngIf="nameList.length > 0" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of nameList | async" [value]="option">
                        {{option.name}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field-->


                <mat-error *ngIf="errorMsjRegister != ''" class="error-center mt-24">{{ errorMsjRegister }}</mat-error>

                <button mat-raised-button color="accent" class="submit-button" aria-label="CREATE AN ACCOUNT" [disabled]="registerForm.invalid || isLoading" (click)="onSubmit()">
                    ENVIAR 
                </button>

                <button mat-stroked-button color="accent" class="submit-button" [disabled]="isLoading" (click)="onCancel()">
                    CANCELAR
                </button>

            </form>

            <!--div class="register" fxLayout="column" fxLayoutAlign="center center" *ngIf="!isAuthority">
                <span class="text">Soy autoridad</span>
                <a class="link" [routerLink]="'/pages/auth/register/authority'">Crear cuenta</a>
            </div>

            <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">Soy ciudadano</span>
                <a class="link" [routerLink]="'/pages/auth/register'">Crear cuenta</a>
            </div-->

            <div class="register-information mb-12" fxLayout="column" fxLayoutAlign="center center">
                <mat-label><strong>¡IMPORTANTE!</strong></mat-label>
                <ul>
                    <li>
                        Una vez recibida tu consulta, nuestros Asesores Ciudadanos te darán respuesta en un término no mayor a 2 días hábiles.
                    </li>
                    <li>
                        La respuesta a tu consulta, se proporcionará única y exclusivamente en relación a los datos que proporciones en tu solicitud y que no exista juicio administrativo o fiscal en trámite.
                    </li>
                    <li>
                        Nos reservamos el derecho de atender tu solicitud en caso de observar irregularidades en los datos ingresados.
                    </li>
                    <li>
                        El uso de esta vía es para el único efecto de asesoría, por lo que no te exime de la responsabilidad de hacer valer tus derechos dentro de los 15 días hábiles a partir de que tuviste conocimiento del acto de molestia.
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>